import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import type {Swiper as SwiperClass, Swiper as SwiperType} from "swiper";

import { RoomMovie } from "../../../api/room";
import RoomMovieCard from "./RoomMovieCard";

import "swiper/css";

import styles from "./RoomMovieCards.module.scss";

interface Props {
  movies: RoomMovie[];
  activeIndex: number;
  onMovieClick: (index: number) => void;
  onSwiper?: (swiper: SwiperType) => void;
  onSlideChange?: (index: number) => void;
  votedIds?: Set<number>;
}

const RoomMovieCards: React.FC<Props> = ({
                                           movies,
                                           activeIndex,
                                           onMovieClick,
                                           onSwiper,
                                           onSlideChange,
                                           votedIds,
                                         }) => {
  if (!movies.length) return null;

  return (
    <Swiper
      onSwiper={onSwiper}
      spaceBetween={16}
      slidesPerView="auto"
      slidesPerGroup={1}
      slidesPerGroupAuto={false}
      breakpoints={{
        0: {
          slidesPerView: 1,
        },
        1024: {
          slidesPerView: "auto",
        },
      }}
      onSlideChange={(swiper: SwiperClass) => {
        onSlideChange?.(swiper.activeIndex);
      }}
      className={styles.swiper}
    >
      {movies.map((movie, index) => (
        <SwiperSlide
          key={movie.id}
          className={`${styles.slide} ${
            activeIndex === index ? styles.active : ""
          }`}
        >
          <RoomMovieCard
            movie={movie}
            onClick={() => onMovieClick(index)}
            isActive={activeIndex === index}
            isVoted={votedIds?.has(movie.id)}
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default RoomMovieCards;
